/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-runloop, ember/require-tagless-components */
import {
  attributeBindings,
  classNames,
  tagName,
} from '@ember-decorators/component';
import Component from '@ember/component';
import { scheduleOnce } from '@ember/runloop';
import moment from 'moment';

// D3 imports
import { select } from 'd3-selection';
import { scaleLinear, scaleTime } from 'd3-scale';
import { line as d3Line } from 'd3-shape';
import { extent } from 'd3-array';
import tip from '@linc-technologies/linced-common/utils/d3-tip';

@tagName('svg')
@classNames('chart', 'chart-sparkline')
@attributeBindings('width', 'height')
export default class ChartSparkline extends Component {
  width = 150;
  height = 50;
  margin = Object.freeze({ top: 4, right: 4, bottom: 4, left: 4 });
  data = [];

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    // Schedule a call to our `draw` method on Ember's "render" queue, which will
    // happen after the component has been placed in the DOM, and subsequently
    // each time data is changed.
    scheduleOnce('render', this, this.draw);
  }

  draw() {
    let plot = select(this.element);
    let data = this.data;
    let margin = this.margin;
    let width = this.width - margin.left - margin.right;
    let height = this.height - margin.top - margin.bottom;

    // Remove previous chart (if there is one), then append the new root element.
    plot.selectAll('*').remove();
    let g = plot
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    let x = scaleTime().rangeRound([0, width]);

    let y = scaleLinear().rangeRound([height, 0]);

    // Tooltip
    let tooltip = tip()
      .attr('class', 'd3-tip')
      .html(
        (d) =>
          `${d.label}<br><br>${moment.unix(d.timestamp).format('D MMM YYYY')}`,
      );
    g.call(tooltip);

    let line = d3Line()
      .x((d) => x(d.timestamp))
      .y((d) => y(d.value));

    // Calculate horizontal extent from timestamps in data
    x.domain(extent(data, (d) => d.timestamp));

    // Calculate vertical extent from values in data
    y.domain(extent(data, (d) => d.value));

    g.append('path')
      .datum(data)
      .attr('fill', 'none')
      .attr('stroke', 'steelblue')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-linecap', 'round')
      .attr('stroke-width', 1.5)
      .attr('d', line);

    g.selectAll('.dot')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', 'dot')
      .attr('cx', (d) => x(d.timestamp))
      .attr('cy', (d) => y(d.value))
      .attr('r', 3)
      .on('mouseover', tooltip.show)
      .on('mouseout', tooltip.hide);
  }
}
